__turbopack_context__.v({
  "footer": "ImagesCard-module-scss-module__klVljG__footer",
});
